/**
 * Central API Configuration
 * 
 * Sources of truth:
 * 1. Runtime environment check (Production vs Development)
 * 2. VITE_API_URL environment variable
 * 3. Fallback to default local port (3002)
 */

export const getApiBaseUrl = () => {
    // If we're in a browser environment
    if (typeof window !== 'undefined') {
        // Check if we are physically on the production domain
        // or if the code was built in production mode
        if (
            import.meta.env.PROD &&
            !window.location.hostname.includes('localhost') &&
            !window.location.hostname.includes('127.0.0.1')
        ) {
            return 'https://proprscout.onrender.com';
        }
    }

    // Use env var or fallback to local default
    return import.meta.env.VITE_API_URL || 'http://localhost:3002';
};

export const API_BASE_URL = getApiBaseUrl();

// Also export the value as default for convenience
export default API_BASE_URL;
